import styled from "styled-components";

export const RelatedSitesWrapperBox = styled.div<{headerHeight?: number;}>`
    height: ${({headerHeight}) => headerHeight ? (headerHeight + "px") : "auto"};
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid ${({theme}) => theme.colors.boxBorder};

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        height: auto;
        display: block;
        border-bottom: none;
        margin: 1rem 0;
    }
`;
